import { List } from "@mui/material"
import { useCallback } from "react"
import { useLocalStorage } from "react-use"
import { initialQuickLookSettings } from "./CmPlayerEventsConstants"
import CmPlayerEventsListItem from "./CmPlayerEventsListItem"

const IGNORED_FIELDS = new Set([
    "table"
])

const CmPlayerEventsList = ({ playerEvent }) => {
    const [settings, setSettings] = useLocalStorage("cm_quick_look_settings", initialQuickLookSettings)

    const handleChange = useCallback((table, eventKey) => {
        if (!Object.hasOwn(settings, table)) {
            setSettings({ ...settings, [table]: [eventKey] })
        } else {
            const tableSettings = settings[table]
            if (tableSettings.includes(eventKey)) {
                tableSettings.splice(tableSettings.indexOf(eventKey), 1)
                setSettings({ ...settings, [table]: tableSettings })
            } else {
                setSettings({ ...settings, [table]: [...tableSettings, eventKey] })
            }
        }
    }, [settings, setSettings])

    return (
        <List dense>
            {Object.entries(playerEvent).filter(([eventKey, _]) => !IGNORED_FIELDS.has(eventKey)).map(([eventKey, eventValue]) => (
                <CmPlayerEventsListItem
                    key={eventKey}
                    table={playerEvent.table}
                    eventKey={eventKey}
                    eventValue={eventValue}
                    checked={settings?.[playerEvent.table]?.includes(eventKey)}
                    onChange={handleChange}
                />
            ))}
        </List>
    )
}

export default CmPlayerEventsList
